<template>
  <div>
    <el-tooltip :content="$t('moneyClaim.new.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button size="md" icon round type="primary" @click="modal = true" class="zi_100">
        <span class="mdi mdi_icon mdi-24px mdi-cash-refund"/>
      </base-button>
    </el-tooltip>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('moneyClaim.new.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('moneyClaim.new.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('moneyClaim.form.amount') }}</label>
            <div class="col-md-9">
              <base-input
                autofocus
                name="amount"
                data-vv-as="'amount'"
                type="number"
                :placeholder="$t('moneyClaim.form.amountPlaceholder')"
                v-validate="modelValidations.amount"
                :error="getError('amount')"
                v-model.number="formDetails.amount"
                step="0.01"
                addon-left-icon="tim-icons icon-coins"/>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('moneyClaim.form.description') }}</label>
            <div class="col-md-9">
              <base-input :error="getError('description')">
                <textarea class="form-control"
                          name="description"
                          data-vv-as="'description'"
                          :placeholder="$t('moneyClaim.form.descriptionPlaceholder')"
                          v-validate="modelValidations.required"
                          v-model="formDetails.description"
                          rows="2"/>
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('moneyClaim.new.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'new-money-claim-btn',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        amount: 0.00,
        description: '',
      },
      modelValidations: {
        amount: {
          required: true,
          min_value: 0.01
        },
        required: {
          required: true
        },
      }
    }
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
  },
  computed: {
    ...mapState({
      updating: state => state.account_money_claim.updating,
      error: state => state.account_money_claim.error,
      data: state => state.account_money_claim.data,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['CreateAccountMoneyClaim', 'LoadAccount', 'LoadAccountMoneyClaims']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      this.alert = false;
      this.CreateAccountMoneyClaim({accountID: this.accountId, payload: this.formDetails}).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.LoadAccount(this.accountId);
          this.LoadAccountMoneyClaims(this.accountId);
          this.$router.push({
            name: 'account-money-claims-details',
            params: {id: this.accountId, money_claim_id: this.data.id}
          }).catch(err => {
          })
          this.$notify({
            type: 'success',
            message: this.$t('moneyClaim.new.createdNotification', {amount: this.$options.filters.money(this.data.amount)}),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        amount: 0.00,
        description: '',
      };

      // reset validation errors
      this.$validator.reset()
    }
  }
}
</script>
